import { render, staticRenderFns } from "./CompanyCertificationForm.vue?vue&type=template&id=4b64b2e0&scoped=true"
import script from "./CompanyCertificationForm.vue?vue&type=script&lang=js"
export * from "./CompanyCertificationForm.vue?vue&type=script&lang=js"
import style0 from "./CompanyCertificationForm.vue?vue&type=style&index=0&id=4b64b2e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b64b2e0",
  null
  
)

export default component.exports